export const B400 = "#136DEC"
export const B300 = "#1A79FF"
export const B500 = "#1458B8"
export const N400 = "#52637A"
// export const B400_100
